/*
 * Actions types
 */
export enum PersonalTypes {
  PERSONAL_RESQUEST = '@personal/PERSONAL_RESQUEST',
  PERSONAL_SUCCESS = '@personal/PERSONAL_SUCCESS',
  PERSONAL_FAILURE = '@personal/PERSONAL_FAILURE',
  CATEGORIA_RESQUEST = '@personal/CATEGORIA_RESQUEST',
  CATEGORIA_SUCCESS = '@personal/CATEGORIA_SUCCESS',
  CATEGORIA_FAILURE = '@personal/CATEGORIA_FAILURE',
}

interface Emails {
  email?: string;
  tipo?: string;
}

interface Enderecos {
  bairro_endereco?: string;
  cependereco?: string;
  cidade_endereco?: string;
  codigo_ibgelogradouro?: any;
  complemento_endereco?: any;
  dddtelefone?: string;
  endereco?: string;
  finalidade_endereco?: string;
  numero_endereco?: string;
  numero_telefone?: string;
  ponto_referencia_end?: string;
  tipo_endereco?: string;
  ufendereco?: string;
  uso_endereco?: any;
}

interface ParqueCliente {
  Categoria_Produto_Cliente?: string;
  Nome_Produto_Cliente?: string;
  Status_Parque_Cliente?: string;
}

interface Telefones {
  ddd?: string;
  ddi?: string;
  nome_contato?: string;
  numero?: string;
  tipo?: string;
}

interface DadosCadastrais {
  Bairro_Proponente?: string;
  CEP_Cobranca_Proponente?: string;
  CEP_Instalacao_Proponente?: string;
  CPF_Proponente?: string;
  Celular_Proponente?: any;
  Celular_pessoal_Proponente?: string;
  Cidade_Cobranca_Proponente?: string;
  Cidade_Instalacao_Proponente?: string;
  Complemento_Cobranca_Proponente?: string;
  Complemento_Instalacao_Proponente?: string;
  Email_Comercial_Proponente?: any;
  Email_Pessoal_Proponente?: string;
  Endereço_Cobranca_Proponente?: string;
  Endereço_Instalacao_Proponente?: string;
  Estado_Instalacao_Proponente?: string;
  Nome_Meio_Poroponente?: any;
  Nome_Proponente?: string;
  Numero_Apartamento_Instalacao_proponente?: any;
  Numero_End_Cobranca_Proponente?: string;
  Numero_End_Instalacao_Proponente?: string;
  RG_Proponente?: string;
  Sobrenome_Proponente?: string;
  Telefone_Comercial_Proponente?: any;
  Telefone_Pessoal_Proponente?: any;
  Telefone_Proponente?: string;
  Tipo_End_Cobranca_Proponente?: string;
  Tipo_End_Instalacao_Proponente?: string;
  Tipo_Residencia_Instalacao_Proponente?: string;
}

interface Propostas {
  Bairro_Logradouro_Proposta_Prosponente?: string;
  CEP_Logradouro_Proposta_Prosponente?: string;
  CPF_Proposta_Prosponente?: string;
  Celular_Pessoal_Proposta_Prosponente?: string;
  Celular_Valido_Proposta_Prosponente?: string;
  Cidade_Logradouro_Proposta_Prosponente?: string;
  Codigo_Cliente_Siebel?: string;
  Codigo_IBGE_Logradouro?: string;
  Complemento_Endereço_Proposta_Prosponente?: string;
  Endereço_Proposta_Prosponente?: string;
  Estado_Logradouro_Proposta_Prosponente?: string;
  Nome_Proposta_Prosponente?: string;
  Numero_Endereço_Proposta_Prosponente?: string;
  Numero_Proposta_Prosponente?: string;
  Numero_apartamento_Proposta_Proponente?: any;
  Sigla_PDV?: string;
  Sobrenome_Proposta_Prosponente?: string;
  Status_Proposta?: string;
  Telefone_Comercial_Proposta_Prosponente?: any;
  Telefone_Residencial_Proposta_Prosponente?: string;
  Tipo_Assinatura?: string;
  Tipo_Endereço_Proposta_Prosponente?: string;
}

interface Instaladores {
  Bairro_Logradouro_Instalador?: string;
  CEP_Logradouro_Instalador?: string;
  CPF_Instalador?: string;
  Celular_Instalador?: any;
  Cidade_Logradouro_Instalador?: string;
  Complemento_Endereco_Instalador: null;
  DDD_Celular_Instalador?: any;
  DDD_Telefone_1_Instalador?: string;
  DDD_Telefone_2_Instalador?: any;
  DDD_Telefone_3_Instalador?: any;
  DDD_Telefone_4_Instalador?: any;
  Email_Instalador?: string;
  Endereco_Instalador?: string;
  Nome_Instalador?: string;
  Numero_Endereco_Instalador?: string;
  Numero_instalador?: string;
  RG_Instalador?: any;
  Telefone_1_Instalador?: string;
  Telefone_2_Instalador?: any;
  Telefone_3_Instalador?: any;
  Telefone_4_Instalador?: any;
  Telefone_Contato_Instalador?: string;
  Telefone_contato_referencia_Instalador?: string;
}

interface PontosDeVenda {
  CPF_Parceiro_Vendedor?: string;
  Celular_Parceiro_Vendedor?: string;
  Email_Parceiro_Vendedor?: string;
  Estado_Civil_Vendedor?: any;
  Foto_Parceiro_Vendedor?: string;
  Genero_Vendedor?: any;
  Nome_Empresa_Vendedor?: string;
  Nome_Parceiro_Vendedor?: string;
  Outro_Telefone_Parceiro_Vendedor?: string;
  RG_Parceiro_Vendedor?: any;
  Sobrenome_Parceiro_Vendedor?: string;
  Telefone_Parceiro_Vendedor?: string;
  Telefone_Res_Parceiro_Vendedor?: any;
}

interface Terceiros {
  CNPJ_Terceiro?: any;
  CPF_Terceiro?: string;
  Caixa_Postal_Terceiro?: any;
  Email_Gestor_Terceiro?: any;
  Email_Terceiro?: string;
  Endereco_Alocacao_Terceiro?: any;
  Endereco_Terceiro?: any;
  Nome_Terceiro?: string;
  Numero_Celular_Terceiro?: any;
  Numero_Fax_Terceiro?: any;
  Numero_Telefone_Reidencia_Terceiro?: any;
  Numero_Telefone_Terceiro?: any;
  RG_Terceiro?: any;
  Sobrenome_Terceiro?: string;
  UF_Terceiro?: any;
}

interface Proponentes {
  CPF_Prosponente?: string;
  Email_Prosponente?: string;
  Nome_Prosponente?: string;
  Passaporte_Prosponente?: any;
  RG_Prosponente?: string;
  Sobrenome_Prosponente?: string;
}

interface Proposta {
  DDD_Telefone_Celular_Proponente?: string;
  DDD_Telefone_Comercial_Proponente?: any;
  DDD_Telefone_Residencial_Proponente?: any;
  Numero_Proposta?: number;
  Telefone_Celular_Proponente?: string;
  Telefone_Comercial_Prosponente?: any;
  Telefone_Residencial_Proponente?: any;
}

interface Dependentes {
  Cartorio_Registor_Dependente?: string;
  DG_RG_Dependente?: string;
  DV_CPF_Dependente?: string;
  Data_Expedicao_RG_Dependente?: string;
  Data_Nascimento_Dependente?: string;
  Estado_Emissor_RG_Dependente?: string;
  Genero_Dependente?: string;
  ID_Parentesco?: string;
  Matricula_Empregado_ATT?: string;
  Matricula_Empregado_SKY?: string;
  NRO_REGISTRO?: string;
  Nome_Dependente?: string;
  Numero_CPF_Dependente?: string;
  Numero_Folha_Registro_Dep?: string;
  Numero_Livro_Registro_Dep?: string;
  Numero_RG_Dependente?: string;
  Orgao_Emissor_RG_Dpendente?: string;
}

interface Beneficiarios {
  Bairro_Beneficiario?: string;
  CEP_Beneficiario?: string;
  Cidade_Beneficiario?: string;
  Complemento_End_Beneficiario?: string;
  DG_RG_Beneficiario?: string;
  DV_CPF_Beneficiario?: string;
  Endereco_Beneficiario?: string;
  Estado_Beneficiario?: string;
  Estado_Emissor_RG_Beneficiario?: string;
  ID_Beneficiario?: string;
  Matricula_Empregado_ATT?: string;
  Matricula_Empregado_SKY?: string;
  Nome_Beneficiario?: string;
  Numero_CPF_Beneficiario?: string;
  Numero_Endereco_Beneficiario?: string;
  Numero_RG_Beneficiario?: string;
  Orgao_Emissor_RG_Beneficiario?: string;
}

interface DadosCadastraisFuncionario {
  Apolice_Seguro_Estagio?: string;
  Bairro_Endereco_Empregado?: string;
  Beneficiarios?: Beneficiarios[];
  CEP_Endereco_Empregado?: string;
  CPF_Coordenador_Estagio?: string;
  CPF_Empregado?: string;
  Carteira_Habilitacao_2019?: string;
  Carteira_Habilitacao_Empregado?: string;
  Categoria_CNH_Empregado?: string;
  Certificado_Reservista_Empregado?: string;
  Cidade_Endereco_Empregado?: string;
  Classe_Contribuicao_INSS_Empregado?: string;
  Codgio_Orgao_Classe_Empregado?: string;
  Codigo_Agencia_Bancaria_Empregado?: string;
  Codigo_Banco_Empregado?: string;
  Codigo_DDD_Telefone_Empregado?: string;
  Codigo_DDI_Telefone_Empregado?: string;
  Complemento_CR_Empregado?: string;
  Complemento_Endereco_Empregado?: string;
  Conta_Corrente_Empregado?: string;
  DDD_Celular_Empregado?: string;
  DDI_Celular_Empregado?: string;
  DT_Expedicao_PIS_Empregado?: string;
  DV_Conta_Corrente_Empregado?: string;
  Data_Admissao_Empregado?: string;
  Data_Expedicao_CNH_Empregado?: string;
  Data_Expedicao_CTPS_Empregado?: string;
  Data_Expedicao_RIC_Empregado?: string;
  Data_Fim_Estagio?: string;
  Data_Nascimento_Empregado?: string;
  Data_Termino_Contrato_Empregado?: string;
  Data_Validade_CNH_Empregado?: string;
  Data_expedicao_Carteira_Hab_2019?: string;
  Dependentes?: Dependentes[];
  Dt_Expedicao_Emissor_RG_Empregado?: string;
  Dt_Expedicao_Orgao_Classe_Empregado?: string;
  Dt_Primeira_Hab_CNH_Empregado?: string;
  Dt_Validade_CTPS_Empregado?: string;
  Dt_Validade_Orgao_Classe_Empregado?: string;
  Email_Pessoal_Empregado?: string;
  Endereco_Residencial_Empregado?: string;
  Estado_CTPS_Empregado?: string;
  Estado_Endereco_Empregado?: string;
  Genero_Empregado?: string;
  Letra_CTPS_Empregado?: string;
  Matricula_Empregado?: string;
  Natureza_Estagio?: string;
  Nome_Coordenador_Estagio?: string;
  Nome_Empregado?: string;
  Nome_Mae_Empregado?: string;
  Nome_Pai_Empregado?: string;
  Numero_Beneficio_INSS_Empregado?: string;
  Numero_CTPS_Empregado?: string;
  Numero_Celular_Empregado?: string;
  Numero_Inscricao_INSS_Empregado?: string;
  Numero_Logradouro_Empregado?: string;
  Numero_PIS_Empregado?: string;
  Numero_RIC_Empregado?: string;
  Numero_Regiao_Orgao_Classe_Empregado?: string;
  Numero_Titulo_Eleitor_Empregado?: string;
  Orgao_Carteira_Habilitacao_2019?: string;
  Orgao_Emissor_CNH_Empregado?: string;
  Orgao_Emissor_RG_Empregado?: string;
  Orgao_Emissor_RIC_Empregado?: string;
  RG_Empregado?: string;
  Regiao_Orgao_Classe_Empregado?: string;
  Secao_TE_Empregado?: string;
  Serie_CTPS_Empregado?: string;
  Situacao_Empregado?: string;
  Telefone_Residencial_Empregado?: string;
  Tipo_Endereco_Empregado?: string;
  UF_Emissor_RG_Empregado?: string;
  UF_Expedicao_CNH_Empregado?: string;
  UF_Orgao_Classe_Empregado?: string;
  Zona_TE_Empregado?: string;
}

interface DadosCadastraisCandidato {
  Bairro_Candidato?: string;
  CPF_Candidato?: string;
  Cidade_Candidato?: string;
  Codigo_Postal_Candidato?: string;
  Complemento_Endereco_cancidato?: string;
  DDD_Celular_candidato?: string;
  DDD_Telefone_Comercial_Candidato?: string;
  DDD_Telefone_Fixo_Candidato?: string;
  DDI_Celular_Candidato?: string;
  DDI_Telefone_Comercial_Candidato?: string;
  DDI_Telefone_Fixo_Candidato?: string;
  Data_Cadastro_NIT?: string;
  Data_Emissao_PIS_Candidato?: string;
  Data_Nascimento_Candidato?: string;
  Email_Candidato?: string;
  Endereco_Linha_2_residencial_Candidato?: string;
  Endereco_residencial_Candidato?: string;
  Estado_Candidato?: string;
  Nome_Candidato?: string;
  Numero_Candidato?: string;
  Numero_Celular_Candidato?: string;
  Numero_NIT?: string;
  Numero_PIS_Candidato?: string;
  Numero_RG_Candidato?: string;
  Numero_Telefone_Comercial_Candidato?: string;
  Numero_Telefone_Fixo_Candidato?: string;
  Pais_Logradouro_Candidato?: string;
  Regiao_Logradouro_Candidato?: string;
  Sobrenome_Candidato?: string;
  Tipo_Endereco_Residencia_Candidato?: string;
  Tipo_Telefone_Contato_Principal?: string;
}

interface Contatos {
  Nome_Contato_Cliente?: string;
  Sobrenome_Contato_Cliente?: string;
  email_Contato_Cliente?: string;
}

export interface PersonalAssinante {
  anonym_request?: any;
  autoridade_emissora?: any;
  beneficiarios_dependentes?: any;
  cargo?: any;
  categoria_produto?: any;
  codigo_siebel?: string;
  contatos?: Contatos[];
  cpf?: string;
  ctps_letter?: any;
  ctps_numero?: any;
  ctps_serie?: any;
  dados_cadastrais?: DadosCadastrais[];
  dados_cadastrais_funcionario: DadosCadastraisFuncionario;
  dados_cadastrais_candidato?: DadosCadastraisCandidato[];
  data_nascimento?: string;
  departamento?: any;
  emails?: Emails[];
  emitido_em?: any;
  enderecos?: Enderecos[];
  estado_civil?: any;
  instaladores?: Instaladores[];
  matricula?: any;
  nome?: string;
  nome_empresa_vendedor?: any;
  nomecompleto?: string;
  numero_beneficio_inss?: any;
  numero_proposta?: any;
  orderns_servico?: [];
  parques_cliente?: ParqueCliente[];
  passaporte?: any;
  pontos_de_venda?: PontosDeVenda[];
  proponentes: Proponentes[];
  produto?: any;
  proposta?: Proposta[];
  propostas?: Propostas[];
  rg?: any;
  sobrenome?: string;
  status_conta_cliente?: string;
  status_produto?: any;
  telefones?: Telefones[];
  tem_dependentes?: boolean;
  tem_beneficiarios?: boolean;
  terceiros?: Terceiros[];
  tipo?: number;
  tipo_de_licenca?: any;
}

/*
 * State Type
 */
export interface PersonalState {
  readonly data: PersonalAssinante[];
  readonly categorias: [];
  readonly loading: boolean;
  readonly error: boolean;
}
